import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	templateUrl: "./incompletestudentaddress.component.html",
})
export class IncompleteStudentAddressComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		IncludeMissingPhoneID: "Yes",
		OnlyShowMissingPhoneID: "Yes",
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	schoolList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 227;

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	IncludeMissingPhoneList = [
		//Insert Custom List Items Here
		{
			IncludeMissingPhoneID: "Yes",
			IncludeMissingPhoneName: "Yes",
		},
		{
			IncludeMissingPhoneID: "No",
			IncludeMissingPhoneName: "No",
		},
	];

	OnlyShowMissingPhoneList = [
		//Insert Custom List Items Here
		{
			OnlyShowMissingPhoneID: "Yes",
			OnlyShowMissingPhoneName: "Yes",
		},
		{
			OnlyShowMissingPhoneID: "No",
			OnlyShowMissingPhoneName: "No",
		},
	];

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(227);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.IncludeMissingPhoneID) {
		// 	this.errorMessage = "Select the IncludeMissingPhone"
		// 	return;
		// }

		// if (!this.report.OnlyShowMissingPhoneID) {
		// 	this.errorMessage = "Select the OnlyShowMissingPhone"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 227;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: IncludeMissingPhone
		strParam += "," + this.report.IncludeMissingPhoneID + "|IncludeMissingPhone";

		//Parameter 3: OnlyShowMissingPhone
		strParam += "," + this.report.OnlyShowMissingPhoneID + "|OnlyShowMissingPhone";

		//Parameter 4: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
